/**
 * 左の赤丸（件数）を読み直してほしいときの合図。
 *
 * 赤丸は画面を移るたびに読み直すが、同じ画面の中で件数が変わる操作（参加の申し込みの承認など）の
 * あとは移らないので、その場で合図を出して読み直す（赤丸と一覧の数が食い違ったままにしない）。
 */
const EVENT_NAME = 'admin-menu-counts-changed';

/** 件数が変わったことを知らせる。 */
export function notifyMenuCountsChanged(): void {
  window.dispatchEvent(new Event(EVENT_NAME));
}

/** 合図を受け取る。戻り値を呼ぶと受け取りをやめる。 */
export function onMenuCountsChanged(listener: () => void): () => void {
  window.addEventListener(EVENT_NAME, listener);
  return () => window.removeEventListener(EVENT_NAME, listener);
}
